var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.222,
    height: 19.564,
    viewBox: "0 0 24.222 19.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#056363;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.465,20.8H3.028V5.315A.787.787,0,0,0,2.271,4.5H.757A.787.787,0,0,0,0,5.315V22.434a1.576,1.576,0,0,0,1.514,1.63H23.465a.787.787,0,0,0,.757-.815v-1.63A.787.787,0,0,0,23.465,20.8ZM21.952,6.13H16.366a1.237,1.237,0,0,0-.8,2.087L17.1,9.868l-3.471,3.739L10.154,9.869a1.438,1.438,0,0,0-2.141,0l-3.25,3.5a.86.86,0,0,0,0,1.153l1.07,1.152a.719.719,0,0,0,1.071,0l2.179-2.347,3.471,3.738a1.438,1.438,0,0,0,2.141,0l4.542-4.891,1.533,1.651a1.127,1.127,0,0,0,1.938-.865V6.946A.787.787,0,0,0,21.952,6.13Z",
    transform: "translate(0 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.76d4dcab5b77a97268a5d7e4a4fdb59b.svg";
export { ForwardRef as ReactComponent };